import { Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import Dashboard from "../components/Dashboard";
import Logo from "../assets/logo_sfondo_bianco.png";


const useStyles = makeStyles(theme => ({
    container: {
        height: "100%",
        padding: "1rem",
    },
    logoContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    title: {
        fontWeight: "lighter",
        paddingBottom: "1%",
    },
    listTit: {
        fontWeight: "lighter",
        padding: "1rem",
        fontSize: ".8rem",
    },
    logo: {
        width: "5rem",
    },
}));
function Home() {

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Card>
                <CardContent>
                    <Dashboard />
                </CardContent>
            </Card>
        </div>
    );
}
export default Home;